import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgColorfulRebook2({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M7.2 0a3.75 3.75 0 012.05 6.9c.6.2 1.13.47 1.5.78a.75.75 0 11-.95 1.16A5.1 5.1 0 006.95 8C4.37 8 2.2 10.35 2.2 13.25a.75.75 0 11-1.5 0 6.75 6.75 0 014.35-6.43A3.74 3.74 0 017.2 0zm0 1.5a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z"
          fill="#E72767"
        />
        <path
          d="M11.9 11.17c-.22-.7-1.07-1.67-1.9-1.67-1.25 0-2 .88-2 1.83 0 2.24 3.63 4.18 3.79 4.27a.25.25 0 00.22 0c.16-.09 3.79-2.03 3.79-4.27 0-.95-.75-1.83-2-1.83-.83 0-1.72.99-1.9 1.67z"
          fill="#FF6496"
        />
      </g>
    </svg>
  );
}

SvgColorfulRebook2.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgColorfulRebook2.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgColorfulRebook2 svgRef={ref} {...props} />);
export default ForwardRef;
